export const SWATCH_WIDTH_IN_PX = 18;
export const LARGE_SWATCH_WIDTH_IN_PX = 32;
export const SMALL_SQUARED_SWATCH_WIDTH_IN_PX = 14;
export const SQUARED_SWATCH_WIDTH_IN_PX = 24;
export const LARGE_SQUARED_SWATCH_WIDTH_IN_PX = 36;

export const TestIds = {
  Swatch: "Swatch",
  LargeSwatch: "LargeSwatch",
  EmptySwatch: "EmptySwatch",
  EmptyLargeSwatch: "EmptyLargeSwatch",
  SmallSquaredSwatch: "SmallSquaredSwatch",
  SquaredSwatch: "SquaredSwatch",
  LargeSquaredSwatch: "LargeSquaredSwatch",
  EmptySquaredSwatch: "EmptySquaredSwatch",
  EmptySquaredSmallSwatch: "EmptySquaredSmallSwatch",
  EmptySquaredLargeSwatch: "EmptySquaredLargeSwatch",
  EmptySwatchInner: "EmptySwatch_inner",
  AddSquaredSwatch: "AddSquaredSwatch",
} as const;
